module.exports = __webpack_public_path__ + "static/media/sidebar-arrow-button.cb823bcf.png";